import { render } from "./CategoryPicker.vue?vue&type=template&id=28cb925c&ts=true"
import script from "./CategoryPicker.vue?vue&type=script&lang=ts"
export * from "./CategoryPicker.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__